module.exports = __webpack_public_path__ + "media/Loops 110 Strings 3.b234fe79.wav";